import React from "react";
import "./portfoliolist.scss";

export default function PortFolioList({ title, active, setSelected, id }) {
  return (
    <>
      <li
        className={active ? "portfoliolist active" : "portfoliolist"}
        onClick={() => {
          setSelected(id);
        }}
      >
        {title}
      </li>
    </>
  );
}
